module.exports = __webpack_public_path__ + "static/1-7a16221804d596ebb87f16f00868aae5.png";